import { render, staticRenderFns } from "./CAppStore.vue?vue&type=template&id=1fa331f2"
import script from "./CAppStore.vue?vue&type=script&lang=ts"
export * from "./CAppStore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports